import * as React from 'react';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import { withStyles, Theme } from '@material-ui/core/styles';
import EmptyScreen from "../EmptyPage"
import { Lead } from '../../../entities/site';
import ActionButton from '../../../components/buttons/ActionButton';

interface Column {
  id: 'active' | 'name' | 'campaignName' | 'component';
  label: string;
  minWidth?: number;
}


// interface Data {
//   id:number;
//   active: boolean;
//   name: string;
//   campaign: string;
//   component?: keyof JSX.IntrinsicElements;
// }

interface ContactListProps {
  selectedRowId: string | null;
  data: Lead[];
  classes: any;
  lastKey?: any;
  handleRowCallback: (row:any) => void;
  handleLoadMore?: () => void;
}

interface TableRowComponentProps{
  selectedRowId: string | null;
  row: any;
  classes: any;
  handleRowCallback: (row:Lead) => void;
}

const columns: readonly Column[] = [
  { id: 'component',label:''},
  { id: 'name', label: 'Name', minWidth: 140 },
  { id: 'campaignName', label: 'Campaign', minWidth: 140 },
];


const styles: any = (theme: Theme) => ({
    activeDot: {
      height:8,
      width:8,
      borderRadius:4,
      backgroundColor:'#00B878',
      margin:"0px 15px"
    },
    inactive: {
      height:8,
      width:8,
      margin:"0px 15px"
    },
    headerCell:{
      height:40,
      backgroundColor:"#FFFFFF",
      padding:"12px 0px",
      color:"#627995"
    },
    rowCell:{
      height:50,
      padding:"15px 0px",
      position:'relative'
    },
    activeRow:{
      backgroundColor:"#FFFFFF",
      cursor:"pointer"
    },
    inactiveRow:{
      backgroundColor:"#F9FBFD",
    },
    selectedRow:{
      backgroundColor:"#E4FBF7 !important",
      cursor:"pointer"
    },
    container:{
    },
    verticalBar:{
      width:4,
      height:'100%',
      position:'absolute',
      left:0,
      top:0,
      backgroundColor:'#00B878'
    },
    emptyTableCell:{
      borderBottom:"none !important"
    },
    emptyPageContainer:{
      borderBottom:"none !important",
      padding:0,
      paddingTop:100,
      paddingRight:50
    }
  })

const TableRowComponent  : React.FC<TableRowComponentProps> =(props)=>{
  const { classes, row, handleRowCallback, selectedRowId  } = props;

  const handleRowClick= () => {
    // if(!row.active) { return }
    handleRowCallback(row);
  }

  return (
    <TableRow onClick={handleRowClick} classes={{root: row.id === selectedRowId ? classes.selectedRow : row.active ? classes.activeRow : classes.inactiveRow }} hover role="checkbox" tabIndex={-1} >
      {columns.map((column) => {
        return (
          <TableCell key={column.id} 
            classes={{
              root:classes.rowCell
            }}
            style={{ color: column.id === 'name' ? '#000' : '#627995' }}
            >
            {(row.id === selectedRowId) && (column.id === 'component') && <div className={classes.verticalBar}/>}
            {row[column.id]}
          </TableCell>
        );
      })}
  </TableRow>
  )
}

const  ContactList : React.FC<ContactListProps>=(props)=> {   
  const { classes , data, handleRowCallback, selectedRowId } = props
  const sortBy=(a:Lead)=> a.newMessage? -1 : 1
  const createRows=(row: Lead)=>{
    return {
      component: row.newMessage ? <div className={classes.activeDot}/> : <div className={classes.inactive}/>,
      ...row
    }
  }
  const rows = React.useMemo(()=>{
   // return data.sort(sortBy).map(createRows)
   return data.map(createRows)
  },[data])

  const renderTableRows=(row:any,index:number)=>(
    <TableRowComponent row={row} key={index} handleRowCallback={handleRowCallback} classes={classes} selectedRowId={selectedRowId}/>
  )

  const handleLoadMore = () => {
    if (props.handleLoadMore) {
      props.handleLoadMore();
    }
  }

  return (
    <TableContainer classes={{root:classes.container}}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.id}
                style={{ minWidth: column.minWidth }}
                classes={{
                  root:classes.headerCell
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length > 0 ? 
            rows.map(renderTableRows) : 
          <TableRow>
            <TableCell classes={{
              root:classes.emptyTableCell
            }}/>
            <TableCell colSpan={2} classes={{
              root:classes.emptyPageContainer
            }}>
              <EmptyScreen message='You have nothing to view here'/>
            </TableCell>
          </TableRow> 
          }
          {props.lastKey && (
            <TableRow>
              <TableCell colSpan={3}>
                <ActionButton
                  fullWidth
                  name="Load More"
                  onClick={handleLoadMore}
                />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default withStyles(styles)(ContactList) 


// WEBPACK FOOTER //
// ./src/pages/next-action/contactList/index.tsx